import {Link, useLocation, useNavigate} from 'react-router-dom';
import Filtros from './Filtros';
import Filtro from './Filtro';
import React, { useState, useEffect } from 'react';
import SituacaoEnvioObjeto from './SituacaoEnvioObjeto';

function SituacaoEnvioOjetos() {

  const location = useLocation();
  const [estado, setEstado] = useState(-1);
  const [entidadeId, setEntidadeId] = useState( location.state.entidade_id || -1);
  const [fiscalizacao, setFiscalizacao] = useState(location?.state.operacao_id || 0);
  const [area, setArea] = useState(location.state.area || 'all');
  // console.log("SITUACAO OBJETO STATE",location.state)
  const [situacaoObjetos, setSituacaoObjetos] = useState([]);
  const [situacaoEntidades, setSituacaoEntidades] = useState([]);
  const [estados, setEstados] = useState([{ value: "Todos", label: "..." }]);
  const [fiscalizacoes, setFiscalizacoes] = useState([{ value: "...", label: "..." }]);
  const [fiscalizacaoOperacao, setFiscalizacaoOperacao] = useState([]);
  const [updateCounter, setUpdateCounter] = useState(0);

  const navigate = useNavigate()

  const fetchEstados = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/estados`)
    const json = await data.json()
    setEstados(json)
  }

  const fetchSituacaoObjetos = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes/situacao/objeto/${fiscalizacao}/entidade/${entidadeId}/area/${area}`)
    const json = await data.json()
    setSituacaoObjetos(json)
  }


  const fetchFiscalizacoes = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes`)
    const json = await data.json()
    setFiscalizacoes(json)
  }

  const fetchFiscalizacaoOperacao = async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/dados/fiscalizacoes/${fiscalizacao}/estado/${estado}`)
    const json = await data.json()
    setFiscalizacaoOperacao(json)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setUpdateCounter((prev) => { return prev + 1 })
    }, 40 * 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchEstados()
    fetchFiscalizacoes()
  }, []);

  useEffect(() => {
    fetchFiscalizacaoOperacao()
    //fetchSituacaoObjetos()
    fetchSituacaoObjetos()
  }, [fiscalizacao, estado, updateCounter]);

  const handleEstadoChange = (e) => {
    const valor = e.target.value
    const estadoIndex = e.nativeEvent.target.selectedIndex;
    const estadoText = e.nativeEvent.target[estadoIndex].text;
    const estadoValue = e.nativeEvent.target[estadoIndex].value;
    setEstado(estadoValue)
  }
  const handleFiscalizacaoChange = (e) => {
    const valor = e.target.value
    setFiscalizacao(valor)
  }

  const getPieData = (dado, tipo) => {

    const nao_respondidas = dado?.total - dado?.respondidas
    if (tipo === 'objeto') {
      return [
        { name: 'Respondidas', y: dado?.respondidas, id_objeto: dado.id_objeto },
        { name: 'Não Respondidas', y: nao_respondidas, id_objeto: dado.id_objeto }
      ]
    } else if (tipo === 'entidade') {
      console.log(dado)
      return [
        { name: 'Respondidas', y: dado?.respondidas, id_entidade: dado.id_entidade },
        { name: 'Não Respondidas', y: nao_respondidas, id_entidade: dado.id_entidade }
      ]
    }
  }

  const getRespondidasPercentual = (parte, todo) => {
    const respondidas = parseInt(parte) || 0
    const respondidas_total = parseInt(todo) || 1

    let valor = respondidas / respondidas_total
    valor = valor * 100
    valor = valor.toLocaleString('pt-BR', {
      minimumIntegerDigits: 2,
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    })
    return valor
  }

  const situacaoClick = (e) => {
    const x = e?.point
    console.log("CLICK", x?.id_entidade)
    situacaoObjetos.find(y => y === x?.id_entidade)
  }

  const changeEstadoHandler = (codigo) => {
    setEstado(codigo)
  }

  return (

    <div className="materiais">

      <div className="back-button sombra" onClick={() => navigate(-1)}><span>Voltar para Visão por Área</span></div>
      {/* <Filtros> */}
        {/* <Filtro key="filtroDestino" id="filtroDestino" name="Destino" data={destinos} onChange={handleDestinoChange} /> */}
        {/* <Filtro key="filtroEstado" id="filtroEstado" name="Estado" data={estados} value={estado} onChange={handleEstadoChange} /> */}
        {/* <Filtro key="filtroFiscalizacao" id="filtroFiscalizacao" name="Fiscalizações" data={fiscalizacoes} onChange={handleFiscalizacaoChange} /> */}
      {/* </Filtros> */}

      <div className="main_layout">
        <div className="graficos-situacao" id="graficos-situacao">
          
          {situacaoObjetos.map(x => {
            return <SituacaoEnvioObjeto key={x.id_objeto+x.descricao_objeto+x.respondidas} operacao_id={fiscalizacao} situacao={x} click={situacaoClick} />
          })}
        </div>
      </div>
    </div>
  );
}

export default SituacaoEnvioOjetos;
